module.exports = __webpack_public_path__ + "static/media/menu-home-active.46444f45.svg";